import cogoToast from "cogo-toast";
const options = {
	hideAfter: 3,
	position: "top-center",
};
export const showErrorMessage = (message) =>
	cogoToast.error(message, {
		...options,
		heading: "Error ",
	});
export const showSuccessMessage = (message) =>
	cogoToast.success(message, {
		...options,
		heading: "Success ",
	});
export const showWarningMessage = (message) =>
	cogoToast.warn(message, {
		...options,
		heading: "Warning ",
	});
export const showInfoMessage = (message) =>
	cogoToast.info(message, {
		...options,
		heading: "Information",
	});
export const showLoadingMessage = (message) =>
	cogoToast.loading(message, {
		...options,
		heading: "Loading, please wait...",
	});
